/**
 * @generated SignedSource<<d93b2f273368ba7768a0d48d650b5ee6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ThreadType = "WELLBEING" | "WORK";
export type ChatContextReflectionMutation$variables = {
  from: string;
  message: string;
  reflectionAnswer?: string | null | undefined;
  userId: string;
};
export type ChatContextReflectionMutation$data = {
  readonly createThread: {
    readonly __typename: "ThreadCreated";
    readonly chatChannelUrl: string;
    readonly threadId: string;
    readonly threadTitle: string | null | undefined;
    readonly threadType: ThreadType;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type ChatContextReflectionMutation = {
  response: ChatContextReflectionMutation$data;
  variables: ChatContextReflectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reflectionAnswer"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "initialMessage",
        "variableName": "message"
      },
      {
        "kind": "Variable",
        "name": "reflectionAnswer",
        "variableName": "reflectionAnswer"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "createThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chatChannelUrl",
            "storageKey": null
          }
        ],
        "type": "ThreadCreated",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatContextReflectionMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ChatContextReflectionMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "4cf5915766905e656637de4f70275eaa",
    "id": null,
    "metadata": {},
    "name": "ChatContextReflectionMutation",
    "operationKind": "mutation",
    "text": "mutation ChatContextReflectionMutation(\n  $userId: ID!\n  $message: String!\n  $from: String!\n  $reflectionAnswer: String\n) {\n  createThread(userId: $userId, initialMessage: $message, from: $from, reflectionAnswer: $reflectionAnswer) {\n    __typename\n    ... on ThreadCreated {\n      threadId\n      threadTitle\n      threadType\n      chatChannelUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a99206dcf4b85053917a14cefe75f8e4";

export default node;
